import "../styles/BPM.css";
import React from "react";


function BPMInput({ value = 120, onChange, compact = false }) {
  const handleChange = (e) => {
    const next = Number(e.target.value);
    if (Number.isNaN(next)) {
      onChange?.(120);
    } else {
      onChange?.(Math.min(300, Math.max(1, next)));
    }
  };

  const input = (
    <input
      id="tempoInput"
      type="number"
      min="1"
      max="300"
      value={value}
      onChange={handleChange}
      className={compact ? 'score-meta-tempo-input' : 'control-input'}
      inputMode="numeric"
    />
  );

  if (compact) {
    return (
      <div className="score-meta-control">
        <span className="score-meta-control-label">BPM</span>
        {input}
      </div>
    );
  }

  return (
    <div className="composer-control composer-control--bpm">
      <label htmlFor="tempoInput" className="control-label-stack">
        <span className="control-title">BPM</span>
      </label>
      {input}
    </div>
  );
}

export default BPMInput;
